import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { take, map } from 'rxjs/operators';
import { selectCanGoToStep } from '../pages/login/store/login.selectors';

export const loginStepGuard: CanMatchFn = (
  route: Route,
  _segments: UrlSegment[]
) => {
  const router = inject(Router);
  const store = inject(Store);
  const minStep = (route.data?.['minStep'] as number) ?? 1;

  return store.select(selectCanGoToStep).pipe(
    take(1),
    map(canGoToStep =>
      canGoToStep >= minStep
        ? true
        : router.createUrlTree(['/auth/login/credentials'])
    )
  );
};
